module.exports = __webpack_public_path__ + "img/growthAbility9.31bf5849.png";